import { ColumnCarousel } from './column-carousel';
import { ColumnComparisonTable } from './column-comparison-table';
import { ColumnComparisonTableMobile } from './column-comparison-table-mobile';
import { ColumnGrid } from './column-grid';
import { ColumnTable } from './column-table';

export const columnsMap = {
  grid: ColumnGrid,
  table: ColumnTable,
  carousel: ColumnCarousel,
  comparisonTable: ColumnComparisonTable,
  comparisonTableMobile: ColumnComparisonTableMobile
};
